export default __webpack_public_path__ + "static/media/ban_thu.650ad193.svg";